import { Component, Renderer2, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { BaseServiceService } from "../../services/base-service.service";
import {
  ModalNotifyComponent,
  ModalNotifyTypes,
} from "../modal-notify/modal-notify.component";
import { TipoConector } from "../../models/tipo-conector.model";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";

declare var fabric: any;

@Component({
  selector: "app-tipo-conector",
  templateUrl: "./tipo-conector.component.html",
  styleUrl: "./tipo-conector.component.css",
})
export class TipoConectorComponent {
  @ViewChild(ModalNotifyComponent) modalNotifyComponent!: ModalNotifyComponent;

  dialogComponentCreate: any;
  dialogComponentEdit: any;
  formSubmitted: boolean = false;
  botonProcesando = false;
  textoBotonProcesando = "Cargando...";
  idTipoConector: any;
  getDataTableTipoConectores: any = ["TipoConector", "GetDataTableTipoConector"];

  @ViewChild(DataTableDirective, { static: false })
  dtElement: any;
  dtInstance: DataTables.Api | any = null;
  dtOptButtons: any = [];

  dtOptions: DataTables.Settings = {};
  response: any[] = [];
  titulo: string = "";
  internalDescription: string = "";
  dtTrigger: any;
  valorCompartido: any;
  validateDel: boolean = false;
  dialogComponentCreateTipoConector: any;
  tipoConectorForm: FormGroup | any = null;
  tipoConectorObj: TipoConector;

  booleanColumnRenderer = (data: any, type: any, row: any, meta: any) => {
    if (type === "display") {
      return `<input type="checkbox" disabled ${data ? "checked" : ""}>`;
    }
    return data;
  };

  columnas = [
    { title: "ID", data: "Id" },
    { title: "Nombre", data: "Nombre" },
    { title: "Descripcion", data: "Descripcion" },
    { title: "Version", data: "Version" },
    { title: "Fecha Creación", data: "FechaCreacion" },
    { title: "Usuario Creación", data: "UsuarioCreacion" },
    { title: "Fecha Actualización", data: "FechaActualizacion" },
    { title: "Usuario Actualización", data: "UsuarioActualizacion" },
    {
      title: "Todos Usuarios",
      data: "TodosUsuarios",
      render: this.booleanColumnRenderer,
      orderable: false,
    },
    {
      title: "Activo",
      data: "Activo",
      render: this.booleanColumnRenderer,
      orderable: false,
    },
  ];

  constructor(
    private baseService: BaseServiceService,
    private router: Router,
    private renderer: Renderer2,
    private _formBuilder: FormBuilder
  ) {
    this.tipoConectorObj = new TipoConector();
    this.formInit();
  }

  clearFormTipoConectorCreado() {
    this.tipoConectorObj = new TipoConector();
    this.tipoConectorForm.reset();
    this.idTipoConector = null;
    this.baseService.clearForm();
  }

  clearFormTipoConector() {
    this.baseService.triggerShowModal(
      "Cancelar creacion del tipo de conector",
      "¿Seguro que desea cancelar la creacion del tipo de conector?",
      ModalNotifyTypes.Warning,
      true
    );

    this.modalNotifyComponent.actionConfirmed.subscribe(
      (confirmed: boolean) => {
        if (confirmed) {
          this.dialogComponentCreateTipoConector.close();
          this.clearFormTipoConectorCreado();
        }
      }
    );
  }

  abrirModalCrear() {
    this.clearFormTipoConectorCreado();
    $("#dialogCreateEdit").html("Crear Tipo de Conector");
    $("#btnCreateEdit > span").html("Crear");
    this.tipoConectorForm.controls["Activo"].setValue(true);

    const dialog = document.querySelector(".create-tipo-conectores");
    this.dialogComponentCreateTipoConector = new fabric["Dialog"](dialog);
    this.dialogComponentCreateTipoConector.open();
  }

  async ngOnInit(): Promise<void> {
    this.dtOptButtons.push({
      "button-id": "btnEdit",
      "button-icon": "ms-Icon--EditNote",
      "button-tooltip": "Editar Datos",
    });

    var CheckBoxElements = document.querySelectorAll(".ms-CheckBox");
    for (var i = 0; i < CheckBoxElements.length; i++) {
      new fabric["CheckBox"](CheckBoxElements[i]);
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.attachClickEvents();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.dtTrigger) {
      this.dtTrigger.unsubscribe();
    }
  }

  formInit() {
    this.tipoConectorForm = this._formBuilder.group({
      Nombre: new FormControl("", [
        Validators.required,
        Validators.maxLength(200),
      ]),
      Descripcion: new FormControl("", [
        Validators.required,
        Validators.maxLength(700),
      ]),
      Version: new FormControl(null, [Validators.required]),
      TodosUsuarios: new FormControl(false),
      Activo: new FormControl(false),
    });
  }

  attachClickEvents(): void {
    const editButtons = document.querySelectorAll("#btnEdit");

    editButtons.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        const id = button.getAttribute("data-id");
        this.idTipoConector = id;
        this.abrirModalEditar();
      });
    });
  }

  gridLoaded(event: any) {
    this.dtInstance = event["table"];
  }

  customClick(event: any) {
    try {
      this.idTipoConector = event["data-id"];

      switch (event["button-id"]) {
        case "btnEdit":
          this.abrirModalEditar();
          break;
      }
    } catch (error) {
      console.error("Error al retornar evento datatable", error);
    }
  }

  reloadDataTable(): void {
    this.dtInstance.ajax.reload(undefined, false);
  }

  dialogComponent: any = null;

  async crearEditarTipoConector() {
    this.botonProcesando = true;
    this.tipoConectorObj.Nombre = this.tipoConectorForm.get("Nombre")!.value;
    this.tipoConectorObj.Descripcion =
      this.tipoConectorForm.get("Descripcion")!.value;
    this.tipoConectorObj.Version = this.tipoConectorForm.get("Version")!.value;
    this.tipoConectorObj.TodosUsuarios =
      this.tipoConectorForm.get("TodosUsuarios")!.value;
    this.tipoConectorObj.Activo = this.tipoConectorForm.get("Activo")!.value;

    try {
      if (this.idTipoConector) {
        const response = await this.baseService.update(
          "TipoConector/ActualizarTipoConector",
          this.idTipoConector,
          this.tipoConectorObj
        );

        if (!response.Ok) {
          this.dialogComponentCreate.close();

          let mensajeError = "<ul>";
          response.ValidationErrors.forEach((error: any) => {
            mensajeError += `<li>${error}</li>`;
          });
          mensajeError += "</ul>";

          this.baseService.triggerShowModal(
            "Error al editar Tipo de Conector",
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
          this.botonProcesando = false;
        } else {
          this.dialogComponentCreateTipoConector.close();
          this.baseService.triggerShowModal(
            "Tipo de Conector Editado",
            "Se ha almacenado el registro correctamente ",
            ModalNotifyTypes.Success,
            false
          );
          this.botonProcesando = false;
          this.reloadDataTable();
        }
      } else {
        const response = await this.baseService.create(
          "TipoConector/CrearTipoConector",
          this.tipoConectorObj
        );

        if (!response.Ok) {
          this.dialogComponentCreateTipoConector.close();

          let mensajeError = "<ul>";
          response.ValidationErrors.forEach((error: any) => {
            mensajeError += `<li>${error}</li>`;
          });
          mensajeError += "</ul>";

          this.baseService.triggerShowModal(
            "Error al crear Tipo de Conector",
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
          this.botonProcesando = false;
        } else {
          this.dialogComponentCreateTipoConector.close();

          var example = document.querySelector(".success");
          var dialog = example!.querySelector(".modal-succes");

          this.dialogComponent = new fabric["Dialog"](dialog);
          this.dialogComponent.open();

          this.botonProcesando = false;
          this.reloadDataTable();
        }
      }
    } catch (error: any) {
      this.dialogComponentCreateTipoConector.close();

      let mensajeError = error.error.Error;

      this.baseService.triggerShowModal(
        "Error",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
    }
  }

  cerrarModal() {
    this.dialogComponent.close();
  }

  async abrirModalEditar() {
    try {
      if (this.idTipoConector !== null) {
        const responseById = await this.baseService.update(
          "TipoConector/GetTipoConector",
          this.idTipoConector,
          {}
        );
        if (responseById.Data) {
          const Data = responseById.Data;
          this.tipoConectorForm.controls["Nombre"].setValue(Data.Nombre);
          this.tipoConectorForm.controls["Descripcion"].setValue(
            Data.Descripcion
          );
          this.tipoConectorForm.controls["Version"].setValue(Data.Version);
          this.tipoConectorForm.controls["TodosUsuarios"].setValue(
            Data.TodosUsuarios
          );
          this.tipoConectorForm.controls["Activo"].setValue(Data.Activo);

          $("#dialogCreateEdit").html("Editar Tipo de Conector");
          $("#btnCreateEdit > span").html("Actualizar");

          const dialog = document.querySelector(".create-tipo-conectores");
          this.dialogComponentCreateTipoConector = new fabric["Dialog"](dialog);
          this.dialogComponentCreateTipoConector.open();
        }
      }
    } catch (error: any) {
      this.baseService.triggerShowModal(
        "Error",
        error.Error,
        ModalNotifyTypes.Danger,
        false
      );
    }
  }

  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, "");
  }
}
